import { sentryReduxOptions } from '@/app/sentryReduxOptions';
import { rootReducer } from '@/app/store/rootReducer';
import { registerAnalysisSpecTags } from '@/model/analysisSpec/tags';
import { baseApi } from '@/model/client';
import { registerEntitlementsTags } from '@/model/entitlements/tags';
import { registerEtlSourcesTags } from '@/model/etlSource/tags';
import { registerProfilingTags } from '@/model/profiling/tags';
import { registerProjectTags } from '@/model/project/tags';
import { registerSourceStateTags } from '@/model/sourceState/tags';
import { registerWorkspaceTags } from '@/model/workspace/tags';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import * as Sentry from '@sentry/react';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistStore } from 'redux-persist';

registerAnalysisSpecTags();
registerEntitlementsTags();
registerEtlSourcesTags();
registerProfilingTags();
registerProjectTags();
registerSourceStateTags();
registerWorkspaceTags();

const sentryReduxEnhancer = Sentry.createReduxEnhancer(sentryReduxOptions);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
  devTools: import.meta.env.DEV,
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
